export default "__VITE_ASSET__BexrbisC__"